import apiCall from '@/utils/apiCall';
import { keyBy } from 'lodash';

export default {
    /**
     * Load user shows
     *
     * @param  {object}    store        Vuex store.
     * @param  {object}    store.state  Vuex state.
     * @param  {Function}  store.commit Method to commit a mutation.
     * @returns {Promise}               Promise.
     */
    async loadShows({
        state,
        commit,
    }, { force = false } = {}) {
        if (state.shows && false === force) {
            return;
        }

        const { status, data } = await apiCall(this._vm, 'get', '/api/shows');

        if (200 === status && data) {
            // Change array to object keyed by hash
            commit('setShows', keyBy(data, 'hash'));
        } else {
            commit('setShows', false);
        }
    },

    /**
     * Convert  show
     *
     * @param  {object}    store                        Vuex store.
     * @param  {Function}  store.commit                 Method to commit a mutation.
     * @param  {object}    payload                     Payload object.
     * @param  {number}    payload.showHash            Show hash.
     * @param  {number}    payload.subscriptionId      User subscription ID.
     *
     * @returns {Promise}               Promise.
     */
    async convertShow(
        { commit },
        { showHash, subscriptionId = null, planId, feedUrl }
    ) {
        const { status, data } = await apiCall(this._vm, 'put', `/api/shows/${showHash}/convert`, {
            subscriptionId,
            planId,
            feedUrl,
        });

        if (200 !== status) {
            throw data.message;
        }

        commit('addShow', { [showHash]: { ...data } });
    },

    /**
     * Update show action
     *
     * @param  {object}    store            Vuex store.
     * @param  {Function}  store.commit     Method to commit a mutation.
     * @param  {object}    payload          Payload object.
     * @param  {number}    payload.hash     Show hash.
     * @param  {object}    payload.newShowData      Data to update.
     *
     * @returns {Promise}               Promise.
     */
    async updateShow({ commit }, { hash, newShowData }) {
        const { status, data } = await apiCall(this._vm, 'put', `/api/shows/${hash}`, newShowData);

        if (200 !== status) {
            throw data.message;
        }

        commit('updateShow', { hash: data.hash, data });
    },

    /**
     * Update show action
     *
     * @param  {object}    store            Vuex store.
     * @param  {Function}  store.commit     Method to commit a mutation.
     * @param  {string}    hash             Show hash.
     */
    async deleteShow({ commit }, hash) {
        const { status, data } = await apiCall(this._vm, 'delete', `/api/shows/${hash}`);

        if (200 !== status) {
            throw data.message;
        }

        commit('deleteShow', hash);
        commit('clearRecentPlayers', { type: 'archive' });
        commit('clearRecentPlayers', { type: 'track' });
    },

    /**
     * Loads show categories.
     *
     * @param  {object}    store         Vuex store.
     * @param  {Function}  store.commit  Method to commit a mutation
     */
    async loadShowCategories({ commit }) {
        const { status, data } = await apiCall(this._vm, 'get', '/api/shows/category');

        if (200 !== status) {
            throw data.message;
        }

        commit('setShowCategories', data);
    },

    /**
     * Loads directories.
     *
     * @param   {object}    store        Vuex store.
     * @param   {Function}  store.commit Method to commit a mutation.
     *
     */
    async loadDirectories({ commit }) {
        const { status, data } = await apiCall(this._vm, 'get', '/api/directories');

        if (200 !== status) {
            commit('setDirectories', false);
        } else {
            commit('setDirectories', data);
        }
    },
};
